<template>
    <div class="school-admin-courses">
        <PreLoader v-if="isLoading"/>
        <SuperAdminSchoolHead>
            <template v-slot:title>{{ $t('subject') }}</template>
<!--            <template v-slot:right>-->
                <!--<SmartSearchInput></SmartSearchInput>-->
<!--            </template>-->
        </SuperAdminSchoolHead>
        <SmartTable :schools="adminCourses" :total-elements="totalElements" :current-page="currentPage"
                    :page-size="pageSize" :totalPages="totalPages" @leftClick="onLeftClick"
                    @rightClick="onRightClick">
            <template v-slot:head>
                <th class="top-th">ID</th>
                <th>{{ $t('title1') }}</th>
                <th>Код</th>
<!--                <th>{{ $t('kyrgyz') }}</th>-->
            </template>

            <template v-slot:body="{ item }">
<!--                <td v-if="item.disable"><input :disabled="item.disable" type="checkbox"></td>-->
<!--                <td v-else></td>-->
                <td>{{item.id}}</td>
                <td>{{$root.$i18n.locale === 'kg' ? item.courseTitleKG : item.courseTitleRU}} {{item.title}}</td>
<!--                <td :class="{'added': item.disable}">{{ item.title }}</td>-->
<!--                <td :class="{'added': item.disable}">{{ item.courseTitleKG }}</td>-->
                <td :class="{'added': item.disable}">{{ item.code }}</td>
            </template>
        </SmartTable>
    </div>
</template>

<script>
import SuperAdminSchoolHead from '@/components/super-admin/schools/SuperAdminSchoolHead'
import SmartTable from '@/components/table/SmartTable'
import { AdminCourseService } from '@/_services/admin-course.service'
import { CourseService } from '@/_services/course.service'
import PreLoader from '@/components/preloader/PreLoader'
const courseService = new CourseService()
const adminCourseService = new AdminCourseService()

export default {
  name: 'SchoolAdminCourses',
  components: {
    SuperAdminSchoolHead,
    SmartTable,
    PreLoader
  },
  data: () => ({
    isLoading: false,
    items: [],
    adminCourses: [],
    totalElements: 0,
    pageSize: 0,
    currentPage: 1,
    totalPages: 1,
    isAddUser: false,
    itemsSelected: 0
  }),
  computed: {
    userProfile () {
      return this.$store.state.account.profile
    }
  },
  created () {
    this.fetchCourses(0)
  },
  methods: {
    onLeftClick () {
      this.currentPage--
      this.fetchCourses(this.currentPage - 1)
    },
    onRightClick () {
      this.currentPage++
      this.fetchCourses(this.currentPage - 1)
    },
    onCloseModal () {
    },
    fetchCourses (page) {
      this.isLoading = true
      courseService.listBySchool(this.userProfile.schools[0].id)
        .then((res) => {
          this.items = res.content
          return adminCourseService.list('', page, 10)
        })
        .then((res) => {
          this.totalElements = res.totalElements
          this.totalPages = res.totalPages
          this.currentPage = res.number + 1
          this.adminCourses = res.content.map(i => {
            if (this.items.some(it => it.adminCourseId === i.id)) {
              i.disable = true
            }
            return i
          }).sort((a, b) => a.title.localeCompare(b.title))
          this.isLoading = false
        })
        .catch((err) => {
          this.$toast.error(err)
          this.isLoading = false
        })
    },
    onSelect (item) {
      this.adminCourses = this.adminCourses.map(i => {
        if (i.id === item.id) i = item
        return i
      })
      this.itemsSelected = this.adminCourses.filter(i => i.checked).length
    },
    async addCourses () {
      if (this.itemsSelected) {
        for (const item of this.adminCourses) {
          if (item.checked) {
            const data = {
              adminCourseId: item.id,
              archived: false,
              code: item.code,
              schoolId: this.userProfile.schools[0].id
            }
            await courseService.create(data).then(res => {
              console.log(res)
            }).catch(err => console.log(err))
          }
        }
        this.$toast.success(this.$t('successfulCreate'))
        this.fetchCourses()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.school-admin-courses {
    margin-bottom: 50px;
    .smart-table__table tr td {
        &.added {
            background: #6279ffb3;
            color: #fff;
            font-weight: bold;
        }
    }
}

.top-th {
    width: 60px;
}
</style>
